import React from "react";
import { Link } from "react-router-dom";
import PageHero from "../components/PageHero";
import BenefitsList from "../components/BenefitsList";
import SectionHead from "../components/SectionHead";
import CtaBanner from "../components/CtaBanner";
import Icon from "../components/Icon";

function Benefits() {
  return (
    <>
      <PageHero
        eyebrow="Benefits"
        title="Why organizations choose MPeoples HRMS"
        subtitle="The key benefits of moving attendance and HR operations onto MPeoples HRMS."
      />

      <section className="section">
        <div className="container">
          <BenefitsList />
        </div>
      </section>

      <section className="section section--alt">
        <div className="container">
          <SectionHead eyebrow="Business impact" title="What this changes for HR teams" center />
          <div className="section-cta-link section-cta-link--center">
            <Link to="/benefits/impact" className="link-arrow">
              See the business impact <Icon name="arrow" size={14} />
            </Link>
          </div>
        </div>
      </section>

      <CtaBanner />
    </>
  );
}

export default Benefits;
